import {ActionMenu, type AnchoredOverlayProps, type OverlayProps, registerPortalRoot} from '@primer/react'
import {clsx} from 'clsx'
import {useEffect, useRef, useState} from 'react'

import styles from './PortalContainerUtils.module.css'

export const COPILOT_CHAT_MENU_PORTAL_ROOT = 'copilotChatMenuPortalRoot'
export const COPILOT_CHAT_MESSAGES_MENU_PORTAL_ROOT = 'copilotChatMessagesMenuPortalRoot'
export const COPILOT_CHAT_PORTAL_ROOT = 'copilotChatPortalRoot'
export const COPILOT_CHAT_TOPIC_PICKER_PORTAL_ROOT = 'copilotChatTopicPickerPortalRoot'
export const EMBEDDED_MENU_PORTAL_CLASS = styles.embeddedMenuPortalContainer

export const ChatPortalContainer = () => {
  const chatMenuRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    registerPortalRoot(chatMenuRef.current!, COPILOT_CHAT_PORTAL_ROOT)
  }, [])

  return <div ref={chatMenuRef} className={styles.chatPortalContainer} />
}

export const MenuPortalContainer = ({className}: {className?: string}) => {
  const chatMenuRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    registerPortalRoot(chatMenuRef.current!, COPILOT_CHAT_MENU_PORTAL_ROOT)
  }, [])

  return <div ref={chatMenuRef} className={clsx(styles.menuPortalContainer, className)} />
}

export const MessagesPortalContainer = () => {
  const chatMenuRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    registerPortalRoot(chatMenuRef.current!, COPILOT_CHAT_MESSAGES_MENU_PORTAL_ROOT)
  }, [])

  return <div ref={chatMenuRef} />
}

export const TopicPickerPortalContainer = () => {
  const chatMenuRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    registerPortalRoot(chatMenuRef.current!, COPILOT_CHAT_TOPIC_PICKER_PORTAL_ROOT)
  }, [])

  return <div ref={chatMenuRef} />
}

export type MenuOverlayProps = Partial<OverlayProps> &
  Pick<AnchoredOverlayProps, 'align'> & {
    children: React.ReactNode
  }

export const ActionMenuOverlay = ({children, portalContainerName, ...overlayProps}: MenuOverlayProps) => {
  const [mounted, setMounted] = useState(() => typeof document !== 'undefined')
  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setMounted(true), [])

  if (!mounted) return null

  return (
    <ActionMenu.Overlay {...overlayProps} portalContainerName={portalContainerName || COPILOT_CHAT_MENU_PORTAL_ROOT}>
      {children}
    </ActionMenu.Overlay>
  )
}
